export enum Filters {
    CITIES = 'cities',
    STATES = 'states',
    EDM_MIN = 'edmMin',
    EDM_MAX = 'edmMax',
    PRICE_MIN = 'priceMin',
    PRICE_MAX = 'priceMax',
    FROM_DATE = 'fromDate',
    TO_DATE = 'toDate',
    LEAD_TYPES = 'leadTypes',
}
